import { render, staticRenderFns } from "./ContentCard.vue?vue&type=template&id=55e2648d&"
import script from "./ContentCard.vue?vue&type=script&lang=js&"
export * from "./ContentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55e2648d')) {
      api.createRecord('55e2648d', component.options)
    } else {
      api.reload('55e2648d', component.options)
    }
    module.hot.accept("./ContentCard.vue?vue&type=template&id=55e2648d&", function () {
      api.rerender('55e2648d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/ContentCard.vue"
export default component.exports